// Include native controls inside open shadow roots without duplicating their custom-element host.
export function focusableWithin(root) {
  const nodes=[];
  const visit=element=>{
    if(element.matches?.('[hidden], [inert], :disabled, [disabled]'))return;
    if(element.shadowRoot){for(const child of element.shadowRoot.children)visit(child);}
    else if(element.matches?.('button, input:not([type="hidden"]), select, textarea, a[href], [tabindex]')&&element.tabIndex>=0)nodes.push(element);
    for(const child of element.children||[])visit(child);
  };
  for(const child of root.children)visit(child);
  return nodes;
}
export function deepActiveElement(root=document) {
  let active=root.activeElement;
  while(active?.shadowRoot?.activeElement)active=active.shadowRoot.activeElement;
  return active;
}
